<footer
  class="fixed-bottom z-0 border-top"
  [tds-data-loader]="{ key: 'cart-prices', as_overlay: true, delay: 2000 }"
>
  <div class="container-md p-md-0">
    <div class="row row-cols-1 row-cols-sm-2">
      <div class="col">
        @switch (shopping_items_price.orderTypeId) {
          @case (12) {
            <ng-container *ngTemplateOutlet="addRemoveFeature" />
          }
          @default {
            @if (hide_price_content) {
              <div
                class="row row-cols-12 row-cols-sm-2 row-cols-lg-3 mt-3 my-sm-3 lh-1 footer-price-text"
              >
                @if (hide_one_time_cost) {
                  <div class="col d-flex flex-column justify-content-center pe-0">
                    <small class="fw-medium">
                      {{ 'one_time' | translate }}
                      <span class="fw-light">{{ 'costs' | translate }}</span>
                    </small>
                    <h4 class="d-flex flex-wrap mb-0">{{ summary_data.one_time_cost }}</h4>
                  </div>
                }
                @if (shopping_cart?.orderTypeId && ![14].includes(shopping_cart.orderTypeId)) {
                  <div class="col d-flex flex-column justify-content-center">
                    <small class="fw-medium">
                      {{ 'recurring' | translate }}
                      <span class="fw-light">{{ 'costs' | translate }}</span>
                    </small>
                    <div class="d-flex flex-wrap align-items-end">
                      <h4 class="mb-0">{{ summary_data.recurring_cost }}</h4>
                      <small class="fw-normal recurring-price-label">/mo.</small>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      </div>

      <div class="col d-flex align-items-center justify-content-end my-3 my-sm-3 py-sm-1">
        <ng-container *ngTemplateOutlet="btn" />
      </div>
    </div>
  </div>
</footer>

<ng-template #btn>
  @if (show_return_to_dashboard) {
    <button type="button" class="btn btn-outline-secondary" (click)="returnToDashboard()">
      {{ 'return_to_dashboard' | translate }}
    </button>
  } @else if (!skip_button) {
    <button
      class="btn btn-primary price-summary-btn"
      type="button"
      [ngClass]="{ 'px-sm-5': button_label === 'Continue' }"
      [disabled]="button_status"
      (click)="!button_status && continue()"
    >
      <span>{{ button_label }}</span>
    </button>
  } @else {
    <button
      class="btn btn-outline-secondary price-summary-btn"
      type="button"
      [disabled]="button_status"
      (click)="!button_status && continue()"
    >
      <span>{{ 'skip_this_step' | translate }}</span>
    </button>
  }
</ng-template>

<ng-template #addRemoveFeature>
  <div
    class="row row-cols-12 row-cols-sm-2 row-cols-lg-3 my-3 d-flex flex-nowrap align-items-center"
  >
    <div
      class="col w-auto"
      [ngClass]="theme_svc.isDarkTheme() ? 'text-secondary-500' : 'text-secondary'"
    >
      <span class="fw-normal">{{ 'current_feature' | translate }} </span>
      <span>{{ 'costs' | translate }}</span>
      <div class="d-flex flex-wrap align-items-baseline">
        <span class="fw-normal fs-4">
          {{
            shopping_cart && shopping_cart.existing_asset?.line?.price
              ? shopping_cart.existing_asset?.line?.price?.cost_to_currency
              : '- -'
          }}
        </span>
        <small>&nbsp;/mo.</small>
      </div>
    </div>

    <div class="col w-auto d-flex justify-content-center">
      <span class="material-icons fs-2">arrow_forward_ios</span>
    </div>

    <div class="col w-auto" [ngClass]="theme_svc.isDarkTheme() ? 'text-secondary-100' : ''">
      <span class="fw-normal">{{ 'updated_feature' | translate }} </span>
      <span>{{ 'costs' | translate }}</span>
      <div class="d-flex flex-wrap align-items-baseline">
        <span class="fw-normal fs-4">{{ summary_data.recurring_cost }}</span>
        <small>&nbsp;/mo.</small>
      </div>
    </div>
  </div>
</ng-template>
